var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "employees-card-bottom",
          attrs: { "body-style": { padding: 0 } },
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            _vm._l(_vm.tabData, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { id: item.key, label: item.label, name: item.key },
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.activeName === "customer_follow_config"
            ? _c("followRules", {
                ref: "followDataRef",
                attrs: { formData: _vm.customer_follow_config },
                on: { followData: _vm.followData, saveEvt: _vm.saveEvt },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeName === "customer_sea_config"
            ? _c("returnRule", {
                ref: "returnDataRef",
                attrs: { formData: _vm.customer_sea_config },
                on: { returnData: _vm.returnData, saveEvt: _vm.saveEvt },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeName === "customer_approve_config"
            ? _c("approvalRules", {
                ref: "approvalDataRef",
                attrs: { fromData: _vm.tabRuleData },
                on: { approvalData: _vm.approvalData },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }